import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { useAuth } from '../../contexts/AuthContext';

export const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="100vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Platform staff who are not members of any customer company only have the admin console.
  if (user.isPlatformAdmin && !user.company) {
    return <Navigate to="/admin" replace />;
  }

  return children;
};

/** Guards the platform admin area. Unauthenticated -> admin login; authenticated non-admins -> their dashboard. */
export const RequirePlatformAdmin = ({ children, loginPath = '/admin/login' }) => {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
        <CircularProgress />
      </Box>
    );
  }
  if (!user) return <Navigate to={loginPath} state={{ from: location }} replace />;
  if (!user.isPlatformAdmin) return <Navigate to="/dashboard" replace />;
  return children;
};
